import iconFaq from '../assets/icons/icon__faq.svg';
import iconArrowDown from '../assets/icons/icon_arrow_down.svg';
import iconBagNotActive from '../assets/icons/icon_bag_notActive.svg';
import iconBag from '../assets/icons/icon_bag.svg';
import iconBin from '../assets/icons/icon_bin.svg';
import iconClose from '../assets/icons/icon_close.svg';
import iconCopy from '../assets/icons/icon_copy.svg';
import iconDollar from '../assets/icons/icon_dollar.svg';
import iconEth from '../assets/icons/icon_eth.svg';
import iconEthG from '../assets/icons/icon_ethG.svg';
import iconHomeNotActive from '../assets/icons/icon_home_notActive.svg';
import iconHome from '../assets/icons/icon_home.svg';
import iconRadiobutton from '../assets/icons/icon_radiobutton.svg';
import iconWalletNotActive from '../assets/icons/icon_wallet_notActive.svg';
import iconWallet from '../assets/icons/icon_wallet.svg';
import iconOpenEye from '../assets/icons/icon_openEye.svg';
import iconCloseEye from '../assets/icons/icon_closeEye.svg';
import iconDep from '../assets/icons/icon_dep.svg';
import iconTransfer from '../assets/icons/icon_transfer.svg';
import iconCard from '../assets/icons/icon_card.svg';
import iconCardNotActive from '../assets/icons/icon_card_notActive.svg';

import balanceImg1 from '../assets/img/balance_img_1.png';
import balanceImg2 from '../assets/img/balance_img_2.png';
import bgLight from '../assets/img/bg_light.png';
import mainIllustration from '../assets/img/main_illustration.png';
import rewardsLight from '../assets/img/rewards__light.png';
import cardMini from '../assets/img/card_mini.png';
import bgCard from '../assets/img/bg_card.png';

import iconBuyback from '../assets/icons/icon_buyback.svg';
import iconBuybackNotActive from '../assets/icons/icon_buyback_notActive.svg';
import buybackIllustration from '../assets/img/buyback_illustration.png';

import Icon_container_ethereum from '../assets/icons/icon_ethereum.svg';
import TierListSection from '../assets/img/tierlistbg.png';
import CurrentRateLight from '../assets/img/CurrentRateLight.png';
import BalanceContainerBg_1 from '../assets/img/Balancecontainerbg.png';
import BalanceContainerBg_2 from '../assets/img/Balancecontainer2.png';

import sad_icon from '../assets/icons/sad_icon.png';

import Timersection from '../assets/img/Timersection.png';
import Container2 from '../assets/img/Balancecontainer2.png';

import icon_swap from '../assets/icons/icon_swap.svg';

export const resources = {
    icons: {
        faq: iconFaq,
        arrowDown: iconArrowDown,
        bagNotActive: iconBagNotActive,
        bag: iconBag,
        bin: iconBin,
        close: iconClose,
        copy: iconCopy,
        dollar: iconDollar,
        eth: iconEth,
        ethG: iconEthG,
        homeNotActive: iconHomeNotActive,
        home: iconHome,
        radiobutton: iconRadiobutton,
        walletNotActive: iconWalletNotActive,
        wallet: iconWallet,
        eyeOpen: iconOpenEye,
        eyeClose: iconCloseEye,
        dep: iconDep,
        transfer: iconTransfer,
        card: iconCard,

        cardNotActive: iconCardNotActive,
        buyback: iconBuyback,
        buybackNotActive: iconBuybackNotActive,

        Icon_container_ethereum: Icon_container_ethereum,

        sad_icon: sad_icon,

        icon_swap: icon_swap
    },
    images: {
        balanceImg1,
        balanceImg2,
        bgLight,
        mainIllustration,
        rewardsLight,
        cardMini,
        bgCard,
        buybackIllustration,
        TierListSection,
        CurrentRateLight,
        BalanceContainerBg_1,
        BalanceContainerBg_2,
        Timersection,
        Container2
    },
};

// Массив для предзагрузки
export const preloadResources = [
    ...Object.values(resources.icons),
    ...Object.values(resources.images),
];